import {
  Accessor,
  createContext,
  createSignal,
  ParentComponent,
  Setter,
  useContext,
} from 'solid-js';

interface LayerPanelContextProps {
  hiddenByLayerScopeGuids: Accessor<Set<string>>;
  setHiddenByLayerScopeGuids: Setter<Set<string>>;
  visibleLayerModelIds: Accessor<Set<string>>;
  setVisibleLayerModelIds: Setter<Set<string>>;
  isolatedLayerGuids: Accessor<Set<string>>;
  setIsolatedLayerGuids: Setter<Set<string>>;
}

export const LayerListPanelContext = createContext<LayerPanelContextProps>();

export const LayerListPanelProvider: ParentComponent = (props) => {
  const [hiddenByLayerScopeGuids, setHiddenByLayerScopeGuids] = createSignal<
    Set<string>
  >(new Set());
  const [visibleLayerModelIds, setVisibleLayerModelIds] = createSignal<
    Set<string>
  >(new Set());
  const [isolatedLayerGuids, setIsolatedLayerGuids] = createSignal<Set<string>>(
    new Set()
  );

  return (
    <LayerListPanelContext.Provider
      value={{
        hiddenByLayerScopeGuids,
        setHiddenByLayerScopeGuids,
        visibleLayerModelIds,
        setVisibleLayerModelIds,
        isolatedLayerGuids,
        setIsolatedLayerGuids,
      }}
    >
      {props.children}
    </LayerListPanelContext.Provider>
  );
};

export const useLayerListPanel = (): LayerPanelContextProps => {
  const value = useContext(LayerListPanelContext);

  if (!value) {
    throw new Error('Missing context Provider');
  }

  return value;
};
